import { AfterViewInit, ChangeDetectionStrategy, Component, forwardRef, ViewEncapsulation } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { PasswordConfig } from "./password.config";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { PasswordModule } from "primeng/password";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector:    'v-password',
    templateUrl: './password.component.haml',
    styleUrls:   ['./password.component.sass', '../input.style.sass'],
    providers:   [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VPasswordComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VPasswordComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VPasswordComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation:   ViewEncapsulation.None,
    imports:         [CommonModule, PasswordModule, ReactiveFormsModule, TranslateModule]
})
export class VPasswordComponent extends InputFormWrapper<PasswordConfig, string> implements AfterViewInit {
    protected readonly _baseConfig: PasswordConfig = PasswordConfig.baseTheme.Default;
    private didInit = false;

    ngAfterViewInit(): void {
        this.writeValue(this.value);
        this.didInit = true;
    }

    /**
     * p-password only inits some properties in ngOnInit but write value might be called beforehand
     * @param value 
     * @returns 
     */
    writeValue(value: string): void {
        if (!this.didInit) return;
        this.formControlDirective()?.valueAccessor.writeValue(value);
        this.value = value;
    }
}